import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, CardMedia, Input, Select, MenuItem, SelectChangeEvent } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddTemplate({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    const [status, setStatus] = useState("default");
    const handleStatusChange = (event: SelectChangeEvent) => {
        setStatus(event.target.value as string);
    };

    const [image, setImage] = useState<string>("");

    const [fileName, setFileName] = useState<string>("");
    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Template</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" action="">

                   
                        <div className="control_group">
                            <label htmlFor="reject-reason">Template Title</label>
                            <TextField
                                id="reject-reason"
                                placeholder="Enter "
                                fullWidth
                                hiddenLabel
                            />
                        </div>

                        <div className="footer_btn_flex">

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
